import type { FactoryProduct } from '@/models';
import type { ProductRosterDetail } from '@/models/ProductRosterDetail';
import type {
  CustomTextConfig,
  ProductionComposeInput,
} from '@/composables/useProductionFileEngine';

/**
 * Map an order line (factory product) + one roster row to a compose input,
 * baking the row's name/number into the product's name/number text slots —
 * the same mapping the per-row "Download SVG" flow uses.
 */
export function buildComposeInputForRow(
  product: FactoryProduct,
  row: ProductRosterDetail
): ProductionComposeInput {
  const customTexts: CustomTextConfig[] = product.product_custom_texts
    ? JSON.parse(JSON.stringify(product.product_custom_texts))
    : [];

  const nameIndex = customTexts.findIndex((t: any) => (t as any).type === 'name');
  const numberIndex = customTexts.findIndex((t: any) => (t as any).type === 'number');
  if (nameIndex !== -1) customTexts[nameIndex].value = row.text ?? '';
  if (numberIndex !== -1) customTexts[numberIndex].value = String(row.number ?? '');

  return {
    designUrl: product.production_design_url ?? '',
    sizesUrl: product.design_sizes_url || undefined,
    safeZoneUrl: product.design_safezone_url || undefined,
    size: row.size ?? '',
    groupPatterns: Array.isArray(product.group_patterns) ? {} : (product.group_patterns ?? {}),
    custom_logos: product.custom_logos ?? [],
    texts: customTexts,
    svgGroups: product.svg_groups ?? [],
    logos: product.fixed_logos ?? [],
  };
}
